module.exports = ".game-state {\n   border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n   background-color: #f7f7f9;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/game-state/game-state.component.css
// module id = ./src/app/web/game/game-state/game-state.component.css
// module chunks = main